import { type CellContext } from '@tanstack/react-table';

import dayjs from 'dayjs';

interface CellDateProps<TData, TValue> extends CellContext<TData, TValue> {
    dateTimeFormatOptions?: Intl.DateTimeFormatOptions;
}

/*
 * This is a cell renderer for a date value in a common format in the table.
 * Format is: MM/DD/YYYY
 */
export default function CellDate<TData, TValue>({ cell }: CellDateProps<TData, TValue>) {
    // We want to format the date if there is one in the cell
    const dateFormat = import.meta.env.VITE_DATE_FORMAT || 'DD.MM.YYYY';

    const date = cell.getValue() as string;
    const formattedDate = date ? dayjs(date).format(dateFormat) : '-';

    return <span className="whitespace-nowrap">{formattedDate}</span>;
}
